import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Input,
  notification,
} from 'antd';
import * as Auth from 'aws-amplify/auth';
import { ConsoleLogger as Logger } from 'aws-amplify/utils';
import { withTranslation } from 'react-i18next';

import { generateNotificationFromCognitoError } from '../../utils/errorHelpers';

import './index.less';

const logger = new Logger('forgot-password:form');

const ForgotPasswordForm = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t, setUserEmail } = props;

  const handleOnFinish = async (body) => {
    setIsLoading(true);
    try {
      const { email } = body;
      const {
        nextStep: {
          codeDeliveryDetails: { deliveryMedium },
        },
      } = await Auth.resetPassword({ username: email });

      const mediumType = (deliveryMedium || '').toLowerCase();

      notification.success({
        message: t(`forgotPassword.form.message.${mediumType}VerificationCode`),
        description: '',
      });
      setUserEmail(email);
    } catch (error) {
      logger.error(error);
      const message = generateNotificationFromCognitoError(t, error);
      notification.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Form
        className="forgot-password-form"
        onFinish={handleOnFinish}
      >
        <Form.Item
          label={t('forgotPassword.form.label.email')}
          colon={false}
          name="email"
          rules={[
            { required: true, message: t('common.form.emptyInputFieldErrorMessage') },
            { type: 'email', message: t('forgotPassword.form.message.emailType') },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item className="submit-button">
          <Button
            type="primary"
            htmlType="submit"
            data-testid="submit-button"
            loading={isLoading}
          >
            {isLoading ? t('common.status.sending') : t('common.button.submit')}
          </Button>
        </Form.Item>
      </Form>
      <p className="forgot-password__login-container">
        <a href="/">
          {t('common.button.backToSignIn')}
        </a>
      </p>
    </>
  );
};

ForgotPasswordForm.displayName = 'ForgotPasswordForm';
ForgotPasswordForm.propTypes = {
  setUserEmail: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ForgotPasswordForm);
export { ForgotPasswordForm as PureComponent };
